import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import PlanosAvulsos from '../components/PlanosAvulsos';
import { buildWhatsAppPlanUrl } from '../utils/whatsapp';
import { fetchDadosSite } from '../utils/dadosSite';
import {
  IconFlame, IconZap, IconUsers, IconRocket, IconShield,
  IconTv, IconSmartphone, IconBookOpen, IconGraduationCap, IconIdCard,
  IconCreditCard, IconReceipt, IconStore, IconCheck,
  IconChevronLeft, IconChevronRight,
  IconWifi, IconAward, IconHeadset, IconWrench, IconWallet,
} from '../components/PlanIcons';
import './PlanosPage.css';

// Mapeia a chave 'icone' salva no dados-site.json para o componente de ícone correspondente.
const ICONES_PACOTE = {
  flame: IconFlame,
  zap: IconZap,
  users: IconUsers,
  rocket: IconRocket,
  shield: IconShield,
  tv: IconTv,
  wifi: IconWifi,
  award: IconAward,
  headset: IconHeadset,
  wrench: IconWrench,
  wallet: IconWallet,
  check: IconCheck,
};

const PACOTES_COMPLETOS = [
  {
    nome: 'STANDARD',
    precoInteiro: '119', precoCentavos: '90',
    Icon: IconFlame,
    features: ['400MB internet', 'Chip TIM 7GB', 'TV Zapping (replay 7 dias)', 'Skeelo (exclusivo)'],
  },
  {
    nome: 'PLUS',
    precoInteiro: '139', precoCentavos: '90',
    Icon: IconZap,
    features: [
      '500MB internet', 'Chip TIM 8GB', 'TV Zapping (replay 7 dias)',
      'Cursos profissionalizantes c/ certificado', 'Acesso à carteirinha de estudante (50% desconto)',
    ],
  },
  {
    nome: 'FAMILY PLUS',
    precoInteiro: '216', precoCentavos: '90',
    Icon: IconUsers,
    features: ['600MB internet', '2 chips TIM 11GB cada', 'TV Zapping (replay 7 dias)'],
  },
  {
    nome: 'ADVANCED',
    precoInteiro: '189', precoCentavos: '90',
    Icon: IconRocket,
    features: [
      '700MB internet', 'Chip TIM 11GB', 'TV Zapping (replay 7 dias)',
      'Cursos profissionalizantes c/ certificado', 'Acesso à carteirinha de estudante (50% desconto)',
    ],
  },
  {
    nome: 'INVINCIBLE',
    precoInteiro: '219', precoCentavos: '90',
    Icon: IconShield,
    destaque: true,
    features: [
      '1 Giga internet', 'Chip TIM 11GB', 'TV Zapping (replay 7 dias)',
      'Cursos profissionalizantes c/ certificado', 'Acesso à carteirinha de estudante (50% desconto)',
    ],
  },
];

const SERVICOS = [
  {
    Icon: IconTv,
    title: 'TV — App Zapping',
    desc: 'Pacote Lite Plus, 50 canais abertos, replay até 7 dias. Pode ser usado no celular (em qualquer lugar), no computador ou direto na TV.',
  },
  {
    Icon: IconSmartphone,
    title: 'Chip móvel',
    desc: 'TIM, ligações ilimitadas, pacote de dados renova todo dia 01.',
  },
  {
    Icon: IconBookOpen,
    title: 'Skeelo (e-books)',
    desc: 'Exclusivo do plano Standard, ativação pelo próprio app.',
  },
  {
    Icon: IconGraduationCap,
    title: 'Cursos profissionalizantes',
    desc: '250+ cursos, certificado emitido pela plataforma (Plus, Advanced, Invincible).',
  },
  {
    Icon: IconIdCard,
    title: 'Carteirinha de estudante',
    desc: 'Solicitada à parte pela plataforma (digital R$ 35,90 / física R$ 58,90, validade 1 ano). Dá 50% de desconto em teatros, cinemas e shows.',
  },
];

const CANAIS_COL_1 = [
  { num: 4, nome: 'SBT' }, { num: 5, nome: 'TV Globo' }, { num: 7, nome: 'Record' },
  { num: 8, nome: 'TV Brasil' }, { num: 9, nome: 'RedeTV!' }, { num: 11, nome: 'Gazeta' },
  { num: 13, nome: 'Band' }, { num: 15, nome: 'Zapping Mix' }, { num: 21, nome: 'X Sports' },
  { num: 36, nome: 'ge tv' }, { num: 60, nome: 'Futura' }, { num: 150, nome: 'Rede Brasil de Televisão' },
  { num: 152, nome: 'CentralTV' }, { num: 153, nome: 'RF TV' }, { num: 154, nome: 'PixTV' },
  { num: 156, nome: 'SescTV' }, { num: 157, nome: 'PlayTV' }, { num: 160, nome: 'Canal Gov' },
  { num: 161, nome: 'TV Justiça' }, { num: 162, nome: 'TV Senado' }, { num: 164, nome: 'Canal do Boi' },
];

const CANAIS_COL_2 = [
  { num: 165, nome: 'Canal Solo Fértil' }, { num: 169, nome: 'Agroplus' }, { num: 170, nome: 'AgroCanal' },
  { num: 173, nome: 'TV Aparecida' }, { num: 174, nome: 'TV Evangelizar' }, { num: 175, nome: 'Canção Nova' },
  { num: 176, nome: 'TV Pai Eterno' }, { num: 178, nome: 'Mais Família Play' }, { num: 179, nome: 'Rede CNT' },
  { num: 180, nome: 'Novo Tempo' }, { num: 181, nome: 'Boa Vontade TV' }, { num: 182, nome: 'RIT' },
  { num: 183, nome: 'Rede Vida' }, { num: 184, nome: 'RS 21' }, { num: 185, nome: 'Daystar' },
  { num: 187, nome: 'Urban Brasil (music)' }, { num: 188, nome: 'MPB (music)' }, { num: 189, nome: 'Hits (music)' },
  { num: 190, nome: 'Soft Pop (music)' }, { num: 191, nome: 'Retro (music)' }, { num: 192, nome: 'Classics (music)' },
  { num: 193, nome: 'Rock (music)' }, { num: 195, nome: 'LOF.AI' }, { num: 198, nome: 'Sertanejo (music)' },
  { num: 199, nome: 'Samba e Pagode (music)' },
];

const CANAL_CORES = ['#e8a020', '#4b9bd6', '#3fbf8f', '#e2588a', '#9b7ee8', '#e0715a', '#4fbfc0', '#c9a13b'];

// Gera uma sigla curta (2 letras) a partir do nome do canal para exibir como "logo"
const getChannelInitials = (nome) => {
  const limpo = nome.replace(/\(.*?\)/g, '').trim();
  const palavras = limpo.split(/\s+/).filter(Boolean);
  if (palavras.length === 1) {
    return palavras[0].slice(0, 2).toUpperCase();
  }
  return (palavras[0][0] + palavras[1][0]).toUpperCase();
};

const PAGAMENTOS = [
  {
    Icon: IconReceipt,
    title: 'Mensalidade',
    desc: 'Pré-paga, com cobrança pro rata; enviada por e-mail e WhatsApp.',
  },
  {
    Icon: IconSmartphone,
    title: 'Taxa de instalação e adesão',
    desc: 'Pix, boleto ou cartão, direto pela Central do Assinante (disponível também como app para Android).',
  },
  {
    Icon: IconCreditCard,
    title: 'Cartão de crédito',
    desc: 'À vista ou recorrente — no recorrente é descontado só o valor da mensalidade a cada mês, sem travar o limite do cartão inteiro. Cadastro do cartão recorrente feito somente pela Central do Assinante.',
  },
  {
    Icon: IconStore,
    title: 'Pagamento presencial',
    desc: 'Também disponível via maquininha (Pix ou débito), quando aplicável.',
  },
];

function PlanosPage() {
  const pacotesScrollRef = useRef(null);
  const [pacotes, setPacotes] = useState(PACOTES_COMPLETOS);

  useEffect(() => {
    let cancelado = false;

    fetchDadosSite().then((dados) => {
      if (!cancelado && Array.isArray(dados?.pacotesCompletos) && dados.pacotesCompletos.length > 0) {
        setPacotes(dados.pacotesCompletos.map((pacote) => ({
          ...pacote,
          Icon: ICONES_PACOTE[pacote.icone] || IconFlame,
        })));
      }
    });

    return () => {
      cancelado = true;
    };
  }, []);

  const scrollPacotes = (direction) => {
    const el = pacotesScrollRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * (el.clientWidth * 0.85), behavior: 'smooth' });
  };

  return (
    <div>
      <section
        className="planos-page__hero"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(255, 255, 255, 0.93) 0%, rgba(255, 255, 255, 0.86) 55%, rgba(255, 255, 255, 0.96) 100%), url('/index/banner-planos1.png')",
        }}
      >
        <span className="planos-page__eyebrow">Guia completo de planos, serviços e pagamento</span>
        <h1 className="planos-page__title">Nossos Planos</h1>
        <p className="planos-page__subtitle">
          Internet avulsa ou em pacotes completos com TV, chip móvel, cursos e muito mais.
          Confira as opções e escolha a que combina com você.
        </p>
      </section>

      {/* Planos avulsos */}
      <section className="planos-page__section">
        <div className="planos-page__section-inner">
          <div className="planos-page__section-header">
            <h2 className="planos-page__section-title">Planos de internet avulsa (sem combo)</h2>
          </div>
          <PlanosAvulsos />
        </div>
      </section>

      {/* Pacotes completos */}
      <section className="planos-page__section planos-page__section--alt">
        <div className="planos-page__section-inner">
        <div className="planos-page__section-header">
          <h2 className="planos-page__section-title">Pacotes completos (internet + benefícios)</h2>
          <p className="planos-page__section-desc">
            Internet, TV por streaming, chip móvel e cursos em um plano só. Arraste para o lado
            e compare os pacotes até achar o ideal para você.
          </p>
        </div>
        <div className="planos-carousel">
          <button
            type="button"
            className="planos-carousel__arrow planos-carousel__arrow--prev"
            onClick={() => scrollPacotes(-1)}
            aria-label="Ver pacotes anteriores"
          >
            <IconChevronLeft width={22} height={22} />
          </button>

          <div className="planos-grid" ref={pacotesScrollRef}>
            {pacotes.map((plano) => (
              <div className={`plano-card ${plano.destaque ? 'plano-card--destaque' : ''}`} key={plano.nome}>
                {plano.destaque && <span className="plano-card__ribbon">Melhor Oferta!</span>}
                <div className="plano-card__header">
                  <div className="plano-card__icon"><plano.Icon width={24} height={24} /></div>
                  <h3 className="plano-card__name">{plano.nome}</h3>
                </div>
                <div className="plano-card__body">
                  <div className="plano-card__price">
                    <span className="plano-card__price-value">R$ {plano.precoInteiro},{plano.precoCentavos}</span>
                    <span className="plano-card__price-period">/mês</span>
                  </div>
                  <ul className="plano-card__features">
                    {plano.features.map((f) => (
                      <li key={f}><IconCheck width={16} height={16} />{f}</li>
                    ))}
                  </ul>
                  <a
                    href={buildWhatsAppPlanUrl(plano.nome)}
                    target="_blank"
                    rel="noreferrer"
                    className="plano-card__cta"
                  >
                    Contrate Já
                  </a>
                </div>
              </div>
            ))}
          </div>

          <button
            type="button"
            className="planos-carousel__arrow planos-carousel__arrow--next"
            onClick={() => scrollPacotes(1)}
            aria-label="Ver mais pacotes"
          >
            <IconChevronRight width={22} height={22} />
          </button>
        </div>
        <div className="planos-page__banner">
          <span>Taxa de instalação (todos os planos): <strong>R$ 120,00</strong></span>
          <span>Fidelidade: <strong>12 meses</strong> (avulsos e pacotes completos)</span>
        </div>
        </div>
      </section>

      {/* Detalhes dos serviços */}
      <section className="planos-page__section">
        <div className="planos-page__section-inner">
        <div className="planos-page__section-header">
          <h2 className="planos-page__section-title">Detalhes dos serviços</h2>
        </div>
        <div className="servicos-grid">
          {SERVICOS.map((s) => (
            <div className="servico-card" key={s.title}>
              <div className="servico-card__icon"><s.Icon width={22} height={22} /></div>
              <div>
                <h3 className="servico-card__title">{s.title}</h3>
                <p className="servico-card__desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
        </div>
      </section>

      {/* Lista de canais */}
      <section className="planos-page__section planos-page__section--dark">
        <div className="planos-page__section-inner">
        <div className="planos-page__section-header">
          <h2 className="planos-page__section-title">Lista de canais (App Zapping)</h2>
          <p className="planos-page__section-desc">
            Mais de 40 canais abertos inclusos nos pacotes completos, com replay de até 7 dias
            direto no celular, computador ou na TV.
          </p>
        </div>
        <div className="canais-grid">
          <div className="canais-col">
            {CANAIS_COL_1.map((c, index) => (
              <div className="canal-item" key={c.num}>
                <span className="canal-item__logo" style={{ background: CANAL_CORES[index % CANAL_CORES.length] }}>
                  {getChannelInitials(c.nome)}
                </span>
                <span className="canal-item__num">{c.num}</span>
                <span className="canal-item__name">{c.nome}</span>
              </div>
            ))}
          </div>
          <div className="canais-col">
            {CANAIS_COL_2.map((c, index) => (
              <div className="canal-item" key={c.num}>
                <span className="canal-item__logo" style={{ background: CANAL_CORES[index % CANAL_CORES.length] }}>
                  {getChannelInitials(c.nome)}
                </span>
                <span className="canal-item__num">{c.num}</span>
                <span className="canal-item__name">{c.nome}</span>
              </div>
            ))}
          </div>
        </div>
        </div>
      </section>

      {/* Formas de pagamento */}
      <section className="planos-page__section">
        <div className="planos-page__section-inner">
        <div className="planos-page__section-header">
          <h2 className="planos-page__section-title">Formas de pagamento</h2>
        </div>
        <div className="pagamento-grid">
          {PAGAMENTOS.map((p) => (
            <div className="pagamento-card" key={p.title}>
              <div className="pagamento-card__icon"><p.Icon width={22} height={22} /></div>
              <div>
                <h3 className="pagamento-card__title">{p.title}</h3>
                <p className="pagamento-card__desc">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PlanosPage;
